import type { Promisable } from 'type-fest'

export function setTimeoutPoll(
  fn: () => Promisable<void>,
  time = 1000,
  opts?: {
    /** Whether to skip the first invocation */
    skipFirst?: boolean
  },
) {
  let polling = true
  let timer: number
  let firstRun = true

  async function run() {
    await Promise.all([
      new Promise(resolve => {
        timer = window.setTimeout(resolve, time)
      }),
      Promise.resolve(!(opts?.skipFirst && firstRun) && fn()),
    ])
    if (polling) {
      firstRun = false
      run()
    }
  }

  run()

  return () => {
    polling = false
    window.clearTimeout(timer)
  }
}
